import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError, tl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Lock, PhoneCall, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ContactUnlock({ targetUserId, jobId, compact }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    if (!targetUserId || !user?.id) return;
    try {
      const q = jobId && jobId !== "direct" ? `?job_id=${jobId}` : "";
      const { data } = await api.get(`/contacts/${targetUserId}${q}`);
      setC(data);
    } catch { /* ignore */ }
  }, [targetUserId, jobId, user]);

  useEffect(() => { load(); }, [load]);

  const { readOnly } = useAuth();
  const unlock = async () => {
    if (readOnly) { toast.error("İzleme (salt-okunur) modunda işlem yapamazsınız"); return; }
    setBusy(true);
    try {
      await api.post(`/contacts/${targetUserId}/unlock`, { job_id: jobId && jobId !== "direct" ? jobId : null });
      toast.success("İletişim bilgisi açıldı!");
      load();
    } catch (e) {
      const status = e?.response?.status;
      if (status === 428) { toast.error("Önce telefon numaranızı doğrulayın."); navigate("/hesabim?tab=phone"); }
      else if (status === 402) { toast.error("Yetersiz bakiye."); navigate("/cuzdanim"); }
      else toast.error(apiError(e));
    } finally { setBusy(false); }
  };

  if (!c || c.self) return null;

  if (c.unlocked) {
    return (
      <div className={compact ? "" : "tinted rounded-xl p-3"} data-testid="contact-unlocked-box">
        <a href={`tel:${c.phone}`} className="flex items-center gap-2 text-emerald-600 font-bold" data-testid="contact-phone-link">
          <PhoneCall className="h-4 w-4" /> {c.phone || "Numara yok"}
        </a>
      </div>
    );
  }

  return (
    <div className={compact ? "flex items-center gap-2" : ""}>
      <div className="flex items-center gap-2 text-slate-400 font-mono bg-slate-50 rounded-xl px-3 py-2 text-sm">
        <Lock className="h-4 w-4" /> {c.phone}
      </div>
      <button onClick={unlock} disabled={busy} data-testid="contact-unlock-button"
        className={`${compact ? "" : "w-full mt-2"} inline-flex items-center justify-center gap-2 brand-gradient text-white rounded-xl h-10 px-3 font-semibold`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Lock className="h-4 w-4" /> Kilidi Aç
          {c.strikethrough > c.price && <span className="line-through opacity-70 text-xs">{tl(c.strikethrough)}</span>}
          <span className="font-extrabold">{tl(c.price)}</span></>}
      </button>
    </div>
  );
}
